import React from "react";
import { Box } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import MidasLogo from "../../../customer/midas/components/MidasLogo";
import { dt } from "../../themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  ChatTypingIndicator — Minimal Claude Desktop style
//  Animated gold M + single status line with fade transition
// ═══════════════════════════════════════════════════════════════

interface ChatTypingIndicatorProps {
  currentStep: string | null;
  showAvatar?: boolean;
}

const ChatTypingIndicator: React.FC<ChatTypingIndicatorProps> = ({
  currentStep,
  showAvatar = true,
}) => {
  const { translate } = useTranslation("chatBot");

  // Map current step to display text
  const statusText = currentStep
    ? translate(currentStep)
    : translate("steps.analyzing"); // default while waiting for first status event

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        py: "12px",
        animation: "midasBotMsg 0.25s cubic-bezier(0.4, 0, 0.2, 1) both",
      }}
    >
      {/* Animated logo */}
      {showAvatar && <MidasLogo size="lg" animated="pulse" />}

      {/* Single status line with fade transition */}
      <Box
        key={currentStep} // key change triggers re-mount = fade animation
        sx={{
          fontFamily: dt.font,
          fontSize: "13px",
          fontWeight: 500,
          color: dt.textMuted,
          animation: "midasFadeIn 0.3s ease both",
          "@keyframes midasFadeIn": {
            "0%": { opacity: 0, transform: "translateY(4px)" },
            "100%": { opacity: 1, transform: "translateY(0)" },
          },
        }}
      >
        {statusText}
      </Box>
    </Box>
  );
};

export default ChatTypingIndicator;
